var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpPassport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132.701,
    height: 260.5,
    viewBox: "0 0 132.701 260.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1806",
    transform: "translate(249.426 -341.035) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1641",
    transform: "translate(-251.464 627.752) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Selfie",
    transform: "translate(137.026 326.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5709",
    d: "M245.3,401.3a36.434,36.434,0,0,0,2.5,5.7c.4.8.8,1.5,1.2,2.3a31.326,31.326,0,0,1,1.5,3.2V401.4A44.689,44.689,0,0,1,245.3,401.3Zm109-135.1H261.1c-10.9,0-19.8,9.4-19.8,21V508.1c0,.3.1.7.1,1,0,.2.1.5.1.7s.1.5.1.7v.1a2.544,2.544,0,0,0,.2.7,3.091,3.091,0,0,1,.2.8,2.353,2.353,0,0,1,.2.8c0,.1.1.2.1.3.1.2.2.5.3.7a20.987,20.987,0,0,0,1.5,3,13.03,13.03,0,0,0,1,1.5,16.127,16.127,0,0,0,2.4,2.8,4.346,4.346,0,0,0,.7.6c.2.2.5.4.7.6l1.2.9a1,1,0,0,1,.5.4,4.352,4.352,0,0,0,.7.4c.3.1.4.3.7.4a5.945,5.945,0,0,0,.8.4h.1c.2.1.5.2.7.3a1.422,1.422,0,0,0,.6.2c.2.1.4.1.6.2s.4.1.6.2c.3.1.7.2,1,.3s.5.1.8.2c.6.1,1.2.2,1.9.3a12.1,12.1,0,0,0,1.9.1h93.2c10.4,0,19-8.5,19.8-19.3v-.5h0V287.2C374.1,275.6,365.3,266.2,354.3,266.2ZM365,493.3H250.4V299.8H365V493.3Zm-119.7-92a36.434,36.434,0,0,0,2.5,5.7c.4.8.8,1.5,1.2,2.3a31.326,31.326,0,0,1,1.5,3.2V401.4A44.689,44.689,0,0,1,245.3,401.3Z",
    fill: "#d1d0d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2394",
    width: 126.2,
    height: 193.5,
    transform: "translate(245 299.8)",
    fill: "#f5f4f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5712",
    d: "M353,283.3a5.1,5.1,0,1,1-5.1-5.1h0A5.121,5.121,0,0,1,353,283.3Z",
    fill: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5732",
    d: "M331.8,283.3a2.433,2.433,0,0,1-2.4,2.4H286.8a2.433,2.433,0,0,1-2.4-2.4h0a2.433,2.433,0,0,1,2.4-2.4h42.6a2.311,2.311,0,0,1,2.4,2.4Z",
    fill: "#7d7d7d"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Exclusi\\xF3n_1",
    d: "M373.9,246.7V118.9H569.2V246.7H373.9Z",
    fill: "#afafaf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_300",
    transform: "translate(281 416)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_302",
    "data-name": "Elipse 302",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(266.2 -239.6)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_303",
    "data-name": "Elipse 303",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(266.7 -239.1)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_301",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(549.2 178.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "close_black_24dp",
    transform: "translate(283 445.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8037",
    d: "M266.2-239.6h11.1v11.1H266.2Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8038",
    d: "M275-236.6l-.7-.7-2.6,2.6-2.6-2.6-.7.7L271-234l-2.6,2.6.7.7,2.6-2.6,2.6,2.6.7-.7-2.6-2.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sync_black_24dp_1_",
    transform: "translate(291.221 408.471) rotate(-150)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8035",
    d: "M-110.8,340.6h13.5v13.5h-13.5Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8036",
    d: "M-104,342.9v-1.7l-2.2,2.2,2.3,2.2v-1.7a3.372,3.372,0,0,1,3.4,3.4,3.167,3.167,0,0,1-.4,1.6l.8.8a4.511,4.511,0,0,0-1.4-6.2,5.734,5.734,0,0,0-2.5-.6Zm0,7.8a3.372,3.372,0,0,1-3.4-3.4,3.167,3.167,0,0,1,.4-1.6l-.8-.8a4.511,4.511,0,0,0,1.4,6.2,4.2,4.2,0,0,0,2.4.7v1.7l2.2-2.2L-104,349Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pasaporte-2",
    transform: "translate(427.01 244.639) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2604",
    "data-name": "Grupo 2604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12026-2",
    "data-name": "Trazado 12026-2",
    d: "M9,18.447H132.739v90.378H9Z",
    transform: "translate(-9 -18.447)",
    fill: "#ded4cf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10884",
    "data-name": "Trazado 10884",
    d: "M123.663,24.169H72.5a2.108,2.108,0,0,1-2.11-2.105V19.949a1.5,1.5,0,0,1,1.5-1.5h51.779Z",
    transform: "translate(0.076 -18.447)",
    fill: "#e5e9ea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2412",
    "data-name": "Grupo 2412",
    transform: "translate(78.248 25.429)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2899",
    "data-name": "Rect\\xE1ngulo 2899",
    width: 2.526,
    height: 2.126,
    transform: "translate(4.971 15.953)",
    fill: "#fde3d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11119",
    "data-name": "Trazado 11119",
    d: "M93.717,61.968a1.842,1.842,0,0,1,.528.064v-.783H91.719v2.078A2.006,2.006,0,0,1,93.717,61.968Z",
    transform: "translate(-86.748 -45.296)",
    fill: "#efd0be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11120",
    "data-name": "Trazado 11120",
    d: "M93.2,63.37H91.026a5.006,5.006,0,0,0-5.147,4.252H98.348A5.022,5.022,0,0,0,93.2,63.37Z",
    transform: "translate(-85.879 -45.611)",
    fill: "#fde3d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11121",
    "data-name": "Trazado 11121",
    d: "M97.5,52.915c0,3.677-2.142,6.65-5.179,6.65s-5.179-2.973-5.179-6.65c0-3.66,2.142-6.65,5.179-6.65C95.337,46.265,97.5,49.238,97.5,52.915Z",
    transform: "translate(-86.066 -43.068)",
    fill: "#fde3d5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2395",
    "data-name": "Grupo 2395",
    transform: "translate(10.728 10.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2394",
    "data-name": "Grupo 2394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2393",
    "data-name": "Grupo 2393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11122",
    "data-name": "Trazado 11122",
    d: "M98.512,55.772c-.112.575.1,1.107.464,1.167s.752-.352.851-.927-.1-1.107-.464-1.167S98.623,55.2,98.512,55.772Z",
    transform: "translate(-98.482 -54.838)",
    fill: "#fde3d5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11123",
    "data-name": "Trazado 11123",
    d: "M99.259,55.5l.064.032a.124.124,0,0,1,.064.032c.016.016.048.032.064.064a.332.332,0,0,1,.048.08.236.236,0,0,1,.016.112.742.742,0,0,1-.032.255,1.219,1.219,0,0,1-.08.255.979.979,0,0,1-.112.192c-.016.016-.048.032-.064.048-.016,0-.048.016-.064.016H99.1a.445.445,0,0,0,.064.048c.016.016.048.016.1.032a.4.4,0,0,0,.128-.016.63.63,0,0,0,.224-.192.879.879,0,0,0,.128-.3.534.534,0,0,0,.016-.16c0-.048-.016-.112-.016-.16a.391.391,0,0,0-.064-.144c-.016-.016-.032-.048-.048-.064s-.048-.032-.064-.048a.153.153,0,0,0-.112-.032c-.032-.016-.064,0-.08,0A.27.27,0,0,0,99.259,55.5Z",
    transform: "translate(-98.573 -54.937)",
    fill: "#fde3d5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2398",
    "data-name": "Grupo 2398",
    transform: "translate(0.365 10.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2397",
    "data-name": "Grupo 2397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2396",
    "data-name": "Grupo 2396"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11124",
    "data-name": "Trazado 11124",
    d: "M87.653,55.772c.112.575-.1,1.107-.464,1.167s-.752-.352-.851-.927.1-1.107.464-1.167C87.154,54.781,87.541,55.2,87.653,55.772Z",
    transform: "translate(-86.308 -54.838)",
    fill: "#fde3d5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11125",
    "data-name": "Trazado 11125",
    d: "M87.031,55.5l-.064.032a.124.124,0,0,0-.064.032c-.016.016-.048.032-.064.064a.331.331,0,0,0-.048.08.236.236,0,0,0-.016.112.742.742,0,0,0,.032.255,1.219,1.219,0,0,0,.08.255.977.977,0,0,0,.112.192c.016.016.048.032.064.048.016,0,.048.016.064.016h.064a.445.445,0,0,1-.064.048c-.016.016-.048.016-.1.032a.4.4,0,0,1-.128-.016.631.631,0,0,1-.224-.192.879.879,0,0,1-.128-.3.533.533,0,0,1-.016-.16c0-.048.016-.112.016-.16a.391.391,0,0,1,.064-.144c.016-.016.032-.048.048-.064s.048-.032.064-.048a.153.153,0,0,1,.112-.032c.032-.016.064,0,.08,0A.443.443,0,0,1,87.031,55.5Z",
    transform: "translate(-86.341 -54.937)",
    fill: "#fde3d5"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11126",
    "data-name": "Trazado 11126",
    d: "M88.677,52.644a1.267,1.267,0,0,1,1.712-.527,1.251,1.251,0,0,1,.27.192",
    transform: "translate(-86.295 -43.916)",
    fill: "none",
    stroke: "#845d57",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.912
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11127",
    "data-name": "Trazado 11127",
    d: "M97.194,52.644a1.267,1.267,0,0,0-1.712-.527,1.252,1.252,0,0,0-.27.192",
    transform: "translate(-87.267 -43.916)",
    fill: "none",
    stroke: "#845d57",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.912
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2399",
    "data-name": "Grupo 2399",
    transform: "translate(5.453 12.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11128",
    "data-name": "Trazado 11128",
    d: "M93.644,56.8a.191.191,0,0,1,.064.064.784.784,0,0,1,.144.24.584.584,0,0,1,.032.192.45.45,0,0,1-.064.24c-.032.032-.048.08-.08.1a.691.691,0,0,1-.112.08,1.394,1.394,0,0,1-.24.08c-.08,0-.16.016-.224.016-.08,0-.144-.016-.208-.016a1.912,1.912,0,0,1-.352-.08,2.57,2.57,0,0,1-.32-.144,3.459,3.459,0,0,1,.352-.016h.352c.064,0,.128-.016.192-.016s.128-.016.176-.016c.064-.016.112-.032.16-.048.016-.016.048-.016.064-.032l.048-.048a.253.253,0,0,0,.064-.112.432.432,0,0,0,.016-.144.994.994,0,0,0-.032-.24A.241.241,0,0,1,93.644,56.8Z",
    transform: "translate(-92.285 -56.799)",
    fill: "#ddc6b6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2401",
    "data-name": "Grupo 2401",
    transform: "translate(4.988 13.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11129",
    "data-name": "Trazado 11129",
    d: "M91.738,58.808a1.308,1.308,0,0,0,2.493,0Z",
    transform: "translate(-91.738 -58.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2400",
    "data-name": "Grupo 2400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11130",
    "data-name": "Trazado 11130",
    d: "M91.738,58.788a2.378,2.378,0,0,0,.24.32l.144.144c.048.048.112.08.16.128a1.659,1.659,0,0,0,.335.176l.192.048L93,59.62l.192-.016c.064-.016.112-.032.176-.048a1.313,1.313,0,0,0,.32-.192c.048-.048.1-.08.144-.128s.08-.1.128-.144a1.311,1.311,0,0,0,.112-.16l.1-.176.1.144c-.415,0-.831-.016-1.247-.032C92.569,58.853,92.153,58.837,91.738,58.788Zm0,0c.415-.032.831-.064,1.247-.08s.831-.032,1.247-.032h0a.092.092,0,0,1,.1.088v.009a.061.061,0,0,1-.016.048,1.749,1.749,0,0,1-.224.368,1.43,1.43,0,0,1-.144.16c-.048.048-.112.1-.16.144s-.128.08-.176.128c-.064.032-.128.064-.208.1-.064.016-.144.032-.224.048-.08,0-.128.016-.208.016-.08-.016-.144-.016-.224-.032a.978.978,0,0,1-.208-.064,1.749,1.749,0,0,1-.368-.224,1.208,1.208,0,0,1-.144-.144,1.1,1.1,0,0,1-.128-.16c-.032-.064-.08-.112-.112-.176Z",
    transform: "translate(-91.738 -58.676)",
    fill: "#eabfb9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2403",
    "data-name": "Grupo 2403",
    transform: "translate(2.861 9.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11131",
    "data-name": "Trazado 11131",
    d: "M90.463,54.117a.59.59,0,0,1-.528.623.579.579,0,0,1-.528-.623.59.59,0,0,1,.528-.623A.579.579,0,0,1,90.463,54.117Z",
    transform: "translate(-89.265 -53.494)",
    fill: "#845d57"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2402",
    "data-name": "Grupo 2402",
    transform: "translate(0 0.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11132",
    "data-name": "Trazado 11132",
    d: "M89.751,53.88a.255.255,0,1,1-.255-.255h0A.263.263,0,0,1,89.751,53.88Z",
    transform: "translate(-89.24 -53.625)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11133",
    "data-name": "Trazado 11133",
    d: "M89.783,54.338a.112.112,0,1,1-.112-.112C89.734,54.21,89.783,54.274,89.783,54.338Z",
    transform: "translate(-89.288 -53.714)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2405",
    "data-name": "Grupo 2405",
    transform: "translate(8.262 9.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11134",
    "data-name": "Trazado 11134",
    d: "M95.587,54.117a.59.59,0,0,0,.528.623.579.579,0,0,0,.528-.623.59.59,0,0,0-.528-.623A.579.579,0,0,0,95.587,54.117Z",
    transform: "translate(-95.585 -53.494)",
    fill: "#845d57"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2404",
    "data-name": "Grupo 2404",
    transform: "translate(0.689 0.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11135",
    "data-name": "Trazado 11135",
    d: "M96.394,53.88a.255.255,0,1,0,.255-.255h0A.263.263,0,0,0,96.394,53.88Z",
    transform: "translate(-96.394 -53.625)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11136",
    "data-name": "Trazado 11136",
    d: "M96.413,54.338a.112.112,0,1,0,.112-.112C96.461,54.21,96.413,54.274,96.413,54.338Z",
    transform: "translate(-96.397 -53.714)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11137",
    "data-name": "Trazado 11137",
    d: "M95.192,63.594a5.482,5.482,0,0,1,1.135.464s-1.471,2.462.5,3.564h-8.3c1.455-1.119.384-3.693.384-3.693a5.926,5.926,0,0,1,2.318-.559l1.215,1.342,1.295-1.342A4.681,4.681,0,0,1,95.192,63.594Z",
    transform: "translate(-86.273 -45.612)",
    fill: "#c5e4ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11138",
    "data-name": "Trazado 11138",
    d: "M87.118,54.846",
    transform: "translate(-86.063 -44.344)",
    fill: "#341c10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11139",
    "data-name": "Trazado 11139",
    d: "M90.517,46.415",
    transform: "translate(-86.569 -43.09)",
    fill: "#341c10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2407",
    "data-name": "Grupo 2407",
    transform: "translate(0.767 12.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2406",
    "data-name": "Grupo 2406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11140",
    "data-name": "Trazado 11140",
    d: "M87.483,57.113a.352.352,0,1,1-.352-.352h0A.355.355,0,0,1,87.483,57.113Z",
    transform: "translate(-86.78 -56.761)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11141",
    "data-name": "Trazado 11141",
    d: "M87.452,57.228a.293.293,0,0,1-.192.08.262.262,0,0,1-.192-.08.293.293,0,0,1-.08-.192h0a.262.262,0,0,1,.08-.192.2.2,0,0,1,.112-.064h-.048a.352.352,0,1,0,0,.7.361.361,0,0,0,.335-.255Z",
    transform: "translate(-86.78 -56.764)",
    fill: "#ededed"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11142",
    "data-name": "Trazado 11142",
    d: "M87.448,57.039a.128.128,0,1,1-.128-.128h0a.126.126,0,0,1,.128.124Z",
    transform: "translate(-86.841 -56.783)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2409",
    "data-name": "Grupo 2409",
    transform: "translate(10.901 12.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2408",
    "data-name": "Grupo 2408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11143",
    "data-name": "Trazado 11143",
    d: "M99.388,57.113a.352.352,0,1,1-.352-.352h0A.355.355,0,0,1,99.388,57.113Z",
    transform: "translate(-98.685 -56.761)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11144",
    "data-name": "Trazado 11144",
    d: "M99.357,57.228a.293.293,0,0,1-.192.08.262.262,0,0,1-.192-.08.292.292,0,0,1-.08-.192h0a.262.262,0,0,1,.08-.192.2.2,0,0,1,.112-.064h-.048a.352.352,0,0,0,0,.7h0a.361.361,0,0,0,.335-.255Z",
    transform: "translate(-98.685 -56.764)",
    fill: "#ededed"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11145",
    "data-name": "Trazado 11145",
    d: "M99.353,57.039a.128.128,0,1,1-.128-.128h0a.117.117,0,0,1,.128.106A.089.089,0,0,1,99.353,57.039Z",
    transform: "translate(-98.746 -56.783)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11146",
    "data-name": "Trazado 11146",
    d: "M93.373,44.232a5.808,5.808,0,0,1,4.444,3.74,13.72,13.72,0,0,1-.255,5.595l-.176.927h-.192a9.45,9.45,0,0,0-.32-4.14c-.991-2.894-4.512-2.686-4.512-2.686-3.341.048-4.332,2.11-4.332,2.11-1.167,1.327-.851,4.715-.851,4.715h-.155l-.16-.911a17.025,17.025,0,0,1-.464-4.044c-.176-4.156,3.916-5.211,3.916-5.211A18.167,18.167,0,0,1,93.373,44.232Z",
    transform: "translate(-85.956 -42.761)",
    fill: "#845d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11147",
    "data-name": "Trazado 11147",
    d: "M95.825,44.4c0,1.039-1.327,1.886-2.973,1.886s-2.974-.851-2.974-1.886,1.327-1.886,2.974-1.886C94.483,42.509,95.825,43.36,95.825,44.4Z",
    transform: "translate(-86.474 -42.509)",
    fill: "#845d57"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2410",
    "data-name": "Grupo 2410",
    transform: "translate(4.299 17.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11148",
    "data-name": "Trazado 11148",
    d: "M90.93,65.717a2.556,2.556,0,0,1,1.9-.783,1.312,1.312,0,0,0-1.786.5A1.325,1.325,0,0,0,90.93,65.717Z",
    transform: "translate(-90.929 -63.587)",
    fill: "#96c5e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11149",
    "data-name": "Trazado 11149",
    d: "M91.617,63.389l1.215,1.342a1.722,1.722,0,0,0-1.9.783l.032-2.078A2.046,2.046,0,0,1,91.617,63.389Z",
    transform: "translate(-90.929 -63.381)",
    fill: "#96c5e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2411",
    "data-name": "Grupo 2411",
    transform: "translate(6.186 17.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11150",
    "data-name": "Trazado 11150",
    d: "M95.019,65.806a2.478,2.478,0,0,0-1.854-.863,1.3,1.3,0,0,1,1.749.573A1.346,1.346,0,0,1,95.019,65.806Z",
    transform: "translate(-93.149 -63.592)",
    fill: "#96c5e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11151",
    "data-name": "Trazado 11151",
    d: "M94.441,63.389l-1.295,1.342s1.391-.255,1.854.863l.1-2.158A2.046,2.046,0,0,0,94.441,63.389Z",
    transform: "translate(-93.146 -63.381)",
    fill: "#96c5e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2467",
    "data-name": "Grupo 2467",
    transform: "translate(2.462 23.215)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2900",
    "data-name": "Rect\\xE1ngulo 2900",
    width: 4.108,
    height: 3.469,
    transform: "translate(8.073 25.943)",
    fill: "#fac9aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11888",
    "data-name": "Trazado 11888",
    d: "M24.62,70.7a3.728,3.728,0,0,1,.863.1V69.549H21.375v3.389A3.288,3.288,0,0,1,24.62,70.7Z",
    transform: "translate(-13.302 -43.606)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11889",
    "data-name": "Trazado 11889",
    d: "M23.785,73H20.269s-7.033-.384-8.377,6.922H32.161C30.8,72.636,23.785,73,23.785,73Z",
    transform: "translate(-11.892 -44.119)",
    fill: "#fac9aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11890",
    "data-name": "Trazado 11890",
    d: "M30.747,55.982c0,5.959-3.485,10.806-8.428,10.806s-8.437-4.828-8.437-10.806c0-5.959,3.485-10.806,8.428-10.806C27.261,45.192,30.747,50.02,30.747,55.982Z",
    transform: "translate(-12.188 -39.981)",
    fill: "#fac9aa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2452",
    "data-name": "Grupo 2452",
    transform: "translate(17.441 17.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11891",
    "data-name": "Trazado 11891",
    d: "M32.427,60.629c-.176.943.16,1.788.752,1.9s1.215-.559,1.391-1.5-.16-1.788-.752-1.9C33.224,59.03,32.6,59.7,32.427,60.629Z",
    transform: "translate(-32.38 -59.117)",
    fill: "#fac9aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11892",
    "data-name": "Trazado 11892",
    d: "M33.646,60.208s.032.016.112.048c.032.016.08.016.112.048a.571.571,0,0,1,.1.1.317.317,0,0,1,.064.128c.032.048.016.112.032.176a1.888,1.888,0,0,1-.032.415,2.346,2.346,0,0,1-.128.4.83.83,0,0,1-.192.3.284.284,0,0,1-.112.08c-.032,0-.08.032-.112.016a.5.5,0,0,0-.112-.016.958.958,0,0,0,.1.08c.032.032.08.032.144.048A.524.524,0,0,0,33.823,62a.948.948,0,0,0,.352-.32,1.692,1.692,0,0,0,.208-.5,1.536,1.536,0,0,0,.032-.272.79.79,0,0,0-.032-.272.659.659,0,0,0-.112-.24c-.032-.032-.048-.064-.08-.1-.032-.016-.064-.048-.1-.064a.547.547,0,0,0-.192-.064.453.453,0,0,0-.144,0A.524.524,0,0,0,33.646,60.208Z",
    transform: "translate(-32.528 -59.274)",
    fill: "#dadada"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2453",
    "data-name": "Grupo 2453",
    transform: "translate(0.575 17.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11893",
    "data-name": "Trazado 11893",
    d: "M14.757,60.629c.176.943-.16,1.788-.752,1.9s-1.215-.559-1.391-1.5.16-1.788.752-1.9C13.958,59.03,14.581,59.7,14.757,60.629Z",
    transform: "translate(-12.568 -59.117)",
    fill: "#fac9aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11894",
    "data-name": "Trazado 11894",
    d: "M13.768,60.208s-.032.016-.112.048c-.032.016-.08.016-.112.048a.571.571,0,0,0-.1.1.317.317,0,0,0-.064.128c-.032.048-.016.112-.032.176a1.289,1.289,0,0,0,.048.415,2.344,2.344,0,0,0,.128.4,1.111,1.111,0,0,0,.192.3.284.284,0,0,0,.112.08c.032,0,.08.032.112.016a.5.5,0,0,1,.112-.016.959.959,0,0,1-.1.08c-.032.032-.08.032-.144.048A.524.524,0,0,1,13.606,62a.948.948,0,0,1-.352-.32,1.715,1.715,0,0,1-.208-.5,1.536,1.536,0,0,1-.032-.272.79.79,0,0,1,.032-.272.659.659,0,0,1,.112-.24c.032-.032.048-.064.08-.1.032-.016.064-.048.1-.064a.547.547,0,0,1,.192-.064.453.453,0,0,1,.144,0Z",
    transform: "translate(-12.634 -59.274)",
    fill: "#dadada"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11895",
    "data-name": "Trazado 11895",
    d: "M16.417,55.537a2.077,2.077,0,0,1,3.229-.559",
    transform: "translate(-12.565 -41.358)",
    fill: "none",
    stroke: "#432918",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.912
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11896",
    "data-name": "Trazado 11896",
    d: "M30.256,55.537a2.077,2.077,0,0,0-3.229-.559",
    transform: "translate(-14.143 -41.358)",
    fill: "none",
    stroke: "#432918",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.912
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2454",
    "data-name": "Grupo 2454",
    transform: "translate(8.823 19.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11897",
    "data-name": "Trazado 11897",
    d: "M24.495,62.3a.554.554,0,0,1,.112.112,1.147,1.147,0,0,1,.224.384.859.859,0,0,1,.064.32.749.749,0,0,1-.112.384,1.686,1.686,0,0,0-.144.176.657.657,0,0,1-.176.112,1.8,1.8,0,0,1-.384.128,3.12,3.12,0,0,1-.368.032,2.569,2.569,0,0,1-.352-.032,2.489,2.489,0,0,1-.575-.144,5.548,5.548,0,0,1-.528-.24,4.809,4.809,0,0,1,.575-.032c.176,0,.368-.016.559,0,.1,0,.208-.016.3-.016.112,0,.192-.032.3-.032.1-.016.176-.048.255-.064a.758.758,0,0,1,.112-.048l.08-.064a.6.6,0,0,0,.1-.176.948.948,0,0,0,.032-.224,1.248,1.248,0,0,0-.048-.384A1.1,1.1,0,0,1,24.495,62.3Z",
    transform: "translate(-22.256 -62.301)",
    fill: "#d3ac91"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2456",
    "data-name": "Grupo 2456",
    transform: "translate(8.104 22.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11898",
    "data-name": "Trazado 11898",
    d: "M21.412,65.588a2.137,2.137,0,0,0,4.061,0Z",
    transform: "translate(-21.412 -65.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2455",
    "data-name": "Grupo 2455"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11899",
    "data-name": "Trazado 11899",
    d: "M21.412,65.557a3.2,3.2,0,0,0,.384.528,3.087,3.087,0,0,0,.224.224,2.665,2.665,0,0,0,.255.192,1.763,1.763,0,0,0,.863.352l.3.016.32-.032c.1-.032.192-.048.272-.08a2.159,2.159,0,0,0,.528-.3,1.361,1.361,0,0,0,.224-.208c.064-.08.144-.144.208-.24a1.42,1.42,0,0,0,.176-.255l.16-.272.144.24c-.672,0-1.362-.016-2.03-.048C22.754,65.653,22.084,65.621,21.412,65.557Zm0,0c.672-.064,1.362-.1,2.03-.128s1.362-.048,2.03-.048h0a.16.16,0,0,1,.16.16h0a.144.144,0,0,1-.016.08,3.653,3.653,0,0,1-.368.592c-.064.1-.16.176-.224.255-.08.08-.176.16-.272.24a2.964,2.964,0,0,1-.288.192,2.762,2.762,0,0,1-.32.144c-.112.032-.24.064-.352.1a2.21,2.21,0,0,1-.335.016l-.352-.048A2.715,2.715,0,0,1,22.771,67a2.288,2.288,0,0,1-.592-.368,3.193,3.193,0,0,1-.24-.24c-.064-.1-.144-.176-.208-.272a2.68,2.68,0,0,1-.176-.288Z",
    transform: "translate(-21.412 -65.382)",
    fill: "#dd9a8d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2458",
    "data-name": "Grupo 2458",
    transform: "translate(4.652 15.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11900",
    "data-name": "Trazado 11900",
    d: "M19.325,57.938a.873.873,0,1,1-.863-1.007.936.936,0,0,1,.863,1Z",
    transform: "translate(-17.391 -56.931)",
    fill: "#432918"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2457",
    "data-name": "Grupo 2457",
    transform: "translate(0 0.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11901",
    "data-name": "Trazado 11901",
    d: "M18.155,57.574a.4.4,0,1,1-.4-.4h0a.4.4,0,0,1,.4.392Z",
    transform: "translate(-17.357 -57.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11902",
    "data-name": "Trazado 11902",
    d: "M18.209,58.306a.192.192,0,1,1-.192-.192.185.185,0,0,1,.192.178Z",
    transform: "translate(-17.427 -57.315)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2460",
    "data-name": "Grupo 2460",
    transform: "translate(13.41 15.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11903",
    "data-name": "Trazado 11903",
    d: "M27.647,57.938a.873.873,0,1,0,.863-1.007A.95.95,0,0,0,27.647,57.938Z",
    transform: "translate(-27.645 -56.931)",
    fill: "#432918"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2459",
    "data-name": "Grupo 2459",
    transform: "translate(1.137 0.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11904",
    "data-name": "Trazado 11904",
    d: "M28.98,57.574a.4.4,0,1,0,.4-.4h0a.4.4,0,0,0-.4.392Z",
    transform: "translate(-28.98 -57.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11905",
    "data-name": "Trazado 11905",
    d: "M29,58.306a.192.192,0,1,0,.192-.192A.194.194,0,0,0,29,58.306Z",
    transform: "translate(-28.983 -57.315)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11906",
    "data-name": "Trazado 11906",
    d: "M27.03,73.354a8.245,8.245,0,0,1,1.838.752s-2.4,4,.816,5.8H16.192c2.35-1.823.639-6.01.639-6.01a9.892,9.892,0,0,1,3.788-.911l1.966,2.19L24.68,73A7.877,7.877,0,0,1,27.03,73.354Z",
    transform: "translate(-12.532 -44.117)",
    fill: "#8cd0e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11907",
    "data-name": "Trazado 11907",
    d: "M13.882,59.128",
    transform: "translate(-12.188 -42.056)",
    fill: "#341c10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11908",
    "data-name": "Trazado 11908",
    d: "M19.4,45.42",
    transform: "translate(-13.009 -40.017)",
    fill: "#341c10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2462",
    "data-name": "Grupo 2462",
    transform: "translate(1.215 19.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2461",
    "data-name": "Grupo 2461"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11909",
    "data-name": "Trazado 11909",
    d: "M14.47,62.82a.575.575,0,1,1-.575-.575h0a.573.573,0,0,1,.575.57Z",
    transform: "translate(-13.319 -62.245)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11910",
    "data-name": "Trazado 11910",
    d: "M14.425,63.016a.448.448,0,0,1-.766-.32h0a.475.475,0,0,1,.128-.32.385.385,0,0,1,.192-.112h-.064a.575.575,0,0,0,0,1.151A.566.566,0,0,0,14.458,63C14.445,63,14.445,63,14.425,63.016Z",
    transform: "translate(-13.322 -62.248)",
    fill: "#ededed"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11911",
    "data-name": "Trazado 11911",
    d: "M14.429,62.7a.208.208,0,1,1-.208-.208.193.193,0,0,1,.208.175A.205.205,0,0,1,14.429,62.7Z",
    transform: "translate(-13.422 -62.281)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2464",
    "data-name": "Grupo 2464",
    transform: "translate(17.712 19.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2463",
    "data-name": "Grupo 2463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11912",
    "data-name": "Trazado 11912",
    d: "M33.849,62.82a.575.575,0,1,1-.575-.575h0a.573.573,0,0,1,.575.57Z",
    transform: "translate(-32.698 -62.245)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11913",
    "data-name": "Trazado 11913",
    d: "M33.8,63.016a.448.448,0,0,1-.766-.32h0a.475.475,0,0,1,.128-.32.385.385,0,0,1,.192-.112h-.064a.575.575,0,0,0,0,1.151A.566.566,0,0,0,33.837,63C33.824,63,33.824,63,33.8,63.016Z",
    transform: "translate(-32.701 -62.248)",
    fill: "#ededed"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11914",
    "data-name": "Trazado 11914",
    d: "M33.808,62.7a.208.208,0,1,1-.208-.208.193.193,0,0,1,.208.175A.205.205,0,0,1,33.808,62.7Z",
    transform: "translate(-32.801 -62.281)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11915",
    "data-name": "Trazado 11915",
    d: "M24.043,41.882a9.387,9.387,0,0,1,7.209,6.075c.943,3.788-.432,9.109-.432,9.109l-.272,1.519h-.324a15.473,15.473,0,0,0-.511-6.729c-1.6-4.715-7.337-4.364-7.337-4.364-5.435.08-7.049,3.42-7.049,3.42-1.9,2.174-1.375,7.673-1.375,7.673H13.7L13.428,57.1a27.456,27.456,0,0,1-.766-6.57c-.241-6.78,6.411-8.474,6.411-8.474A28.6,28.6,0,0,1,24.043,41.882Z",
    transform: "translate(-12.006 -39.485)",
    fill: "#341c10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11916",
    "data-name": "Trazado 11916",
    d: "M28.038,42.142c0,1.694-2.158,3.069-4.844,3.069-2.67,0-4.844-1.375-4.844-3.069s2.159-3.069,4.845-3.069C25.865,39.073,28.038,40.448,28.038,42.142Z",
    transform: "translate(-12.853 -39.073)",
    fill: "#341c10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2465",
    "data-name": "Grupo 2465",
    transform: "translate(6.969 28.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11917",
    "data-name": "Trazado 11917",
    d: "M20.079,76.829a4.145,4.145,0,0,1,3.085-1.277S20.8,74.432,20.079,76.829Z",
    transform: "translate(-20.079 -73.357)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11918",
    "data-name": "Trazado 11918",
    d: "M21.205,73.039l1.982,2.19s-2.238-.511-3.085,1.277l.032-3.373A2.576,2.576,0,0,1,21.205,73.039Z",
    transform: "translate(-20.082 -73.019)",
    fill: "#3da4bf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2466",
    "data-name": "Grupo 2466",
    transform: "translate(10.054 28.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11919",
    "data-name": "Trazado 11919",
    d: "M26.724,76.964A4.127,4.127,0,0,0,23.7,75.542C23.7,75.557,26.116,74.536,26.724,76.964Z",
    transform: "translate(-23.703 -73.361)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11920",
    "data-name": "Trazado 11920",
    d: "M25.813,73.037,23.7,75.212s2.254-.415,3.021,1.422l.16-3.517A2.662,2.662,0,0,0,25.813,73.037Z",
    transform: "translate(-23.703 -73.016)",
    fill: "#3da4bf"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11975",
    "data-name": "Trazado 11975",
    d: "M53.943,82.139a3,3,0,0,0,1.55-1.806c.255.623.511,1.231.766,1.854A1.512,1.512,0,0,0,57.2,80.78a5.5,5.5,0,0,0,3.837-.208c-1.135-.144-2.254-.288-3.389-.448a7.436,7.436,0,0,0-2.639-.24c-.879.272-1.422,1.362-1.774,2.142-.112.24-.208.5-.32.752.255-1.215.592-2.462.959-3.644.032.511.016,1.022.032,1.532A6.555,6.555,0,0,1,53.943,82.139Z",
    transform: "translate(-8.545 -18.118)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11976",
    "data-name": "Trazado 11976",
    d: "M93.792,82.77c-.112-.192.208-.352.464-.432,1.262-.368,2.526-.736,3.773-1.107A1.552,1.552,0,0,1,98.78,83.1a3.322,3.322,0,0,1-2.542-.432c-.368-.255-.623-.687-.352-.991a1.335,1.335,0,0,1,.766-.3c.511-.1,1.022-.192,1.532-.3a3.029,3.029,0,0,1,1.311-.048,2.762,2.762,0,0,1,1.055.8,1.389,1.389,0,0,0,1.295.4,7.029,7.029,0,0,0-2.238-.08c-.735.128-1.422.559-1.5,1.135l.479-1.679c.208.655.415,1.327.623,1.982A4.216,4.216,0,0,0,99.783,82c.016.5.032.975.032,1.471a4.073,4.073,0,0,0,1.007-2.158c.288,1.295.575,2.573.9,3.868a4.316,4.316,0,0,0,1.247-2.238,16.869,16.869,0,0,0-4.412-.32,3.7,3.7,0,0,0-2.462.623,27.578,27.578,0,0,0,5.789-3.15c-.3,1.247-.608,2.493-.927,3.74a16.536,16.536,0,0,1,4.971-3.373",
    transform: "translate(-7.538 -17.923)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2901",
    "data-name": "Rect\\xE1ngulo 2901",
    d: "M12.654,20H29.187a1.323,1.323,0,0,1,1.323,1.323h0a1.323,1.323,0,0,1-1.323,1.323H12.654a1.323,1.323,0,0,1-1.323-1.323h0A1.323,1.323,0,0,1,12.654,20Z",
    transform: "translate(-9.347 -18.678)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2903",
    "data-name": "Rect\\xE1ngulo 2903",
    width: 26.453,
    height: 1.984,
    rx: 0.992,
    transform: "translate(43.264 1.983)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2902",
    "data-name": "Rect\\xE1ngulo 2902",
    d: "M11.992,24.662H24.558a.662.662,0,0,1,.661.661h0a.662.662,0,0,1-.661.661H11.992a.662.662,0,0,1-.661-.661h0A.662.662,0,0,1,11.992,24.662Z",
    transform: "translate(-9.347 -19.371)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2905",
    "data-name": "Rect\\xE1ngulo 2905",
    width: 11.243,
    height: 0.661,
    rx: 0.331,
    transform: "translate(38.715 5.952)",
    fill: "#e68855"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2908",
    "data-name": "Rect\\xE1ngulo 2908",
    width: 11.243,
    height: 1.984,
    rx: 0.992,
    transform: "translate(38.715 17.953)",
    fill: "#e68855"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2922",
    "data-name": "Rect\\xE1ngulo 2922",
    width: 11.243,
    height: 0.661,
    rx: 0.331,
    transform: "translate(38.715 36.64)",
    fill: "#e68855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2927",
    "data-name": "Rect\\xE1ngulo 2927",
    d: "M47.78,69.931H57.7a.662.662,0,0,1,.661.661h0a.662.662,0,0,1-.661.661H47.78a.662.662,0,0,1-.661-.661h0A.662.662,0,0,1,47.78,69.931Z",
    transform: "translate(-8.404 -18.411)",
    fill: "#e68855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2925",
    "data-name": "Rect\\xE1ngulo 2925",
    d: "M46.983,59.424h4.629a.662.662,0,0,1,.661.661h0a.662.662,0,0,1-.661.661H46.983a.662.662,0,0,1-.661-.661h0A.662.662,0,0,1,46.983,59.424Z",
    transform: "translate(-8.742 -18.419)",
    fill: "#e68855"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2915",
    "data-name": "Rect\\xE1ngulo 2915",
    width: 7.275,
    height: 0.661,
    rx: 0.331,
    transform: "translate(37.848 27.219)",
    fill: "#e68855"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2916",
    "data-name": "Rect\\xE1ngulo 2916",
    width: 9.258,
    height: 0.661,
    rx: 0.331,
    transform: "translate(50.296 27.219)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2917",
    "data-name": "Rect\\xE1ngulo 2917",
    width: 9.258,
    height: 0.661,
    rx: 0.331,
    transform: "translate(38.268 29.312)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2909",
    "data-name": "Rect\\xE1ngulo 2909",
    d: "M49.105,40.511H66.3a.662.662,0,0,1,.661.661h0a.662.662,0,0,1-.661.661H49.105a.662.662,0,0,1-.661-.661h0A.662.662,0,0,1,49.105,40.511Z",
    transform: "translate(-7.841 -18.432)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2923",
    "data-name": "Rect\\xE1ngulo 2923",
    width: 18.518,
    height: 0.661,
    rx: 0.331,
    transform: "translate(61.484 36.64)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2928",
    "data-name": "Rect\\xE1ngulo 2928",
    width: 18.518,
    height: 0.661,
    rx: 0.331,
    transform: "translate(61.484 52.343)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2924",
    "data-name": "Rect\\xE1ngulo 2924",
    d: "M58.671,59.424h9.92a.662.662,0,0,1,.661.661h0a.662.662,0,0,1-.661.661h-9.92a.662.662,0,0,1-.661-.661h0A.662.662,0,0,1,58.671,59.424Z",
    transform: "translate(-8.234 -18.419)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2926",
    "data-name": "Rect\\xE1ngulo 2926",
    width: 11.904,
    height: 0.661,
    rx: 0.331,
    transform: "translate(38.869 45.015)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2910",
    "data-name": "Rect\\xE1ngulo 2910",
    d: "M47.366,28.546h7.274a.662.662,0,0,1,.661.661h0a.662.662,0,0,1-.661.661H47.366a.662.662,0,0,1-.661-.661h0A.662.662,0,0,1,47.366,28.546Z",
    transform: "translate(-8.58 -19.949)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2918",
    "data-name": "Rect\\xE1ngulo 2918",
    d: "M14.984,99.129H30.856a1.323,1.323,0,0,1,1.323,1.323h0a1.323,1.323,0,0,1-1.323,1.323H14.984a1.323,1.323,0,0,1-1.323-1.323h0A1.323,1.323,0,0,1,14.984,99.129Z",
    transform: "translate(-9.693 -17.149)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2920",
    "data-name": "Rect\\xE1ngulo 2920",
    d: "M15.23,104.567H128.092a1.462,1.462,0,0,1,1.569,1.323h0a1.462,1.462,0,0,1-1.569,1.323H15.23a1.462,1.462,0,0,1-1.569-1.323h0A1.462,1.462,0,0,1,15.23,104.567Z",
    transform: "translate(-9.693 -17.958)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2919",
    "data-name": "Rect\\xE1ngulo 2919",
    d: "M50.894,99.129H66.766a1.323,1.323,0,0,1,1.323,1.323h0a1.323,1.323,0,0,1-1.323,1.323H50.894a1.323,1.323,0,0,1-1.323-1.323h0A1.323,1.323,0,0,1,50.894,99.129Z",
    transform: "translate(-7.808 -17.149)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2921",
    "data-name": "Rect\\xE1ngulo 2921",
    d: "M93.35,99.129h28.437a1.323,1.323,0,0,1,1.323,1.323h0a1.323,1.323,0,0,1-1.323,1.323H93.35a1.323,1.323,0,0,1-1.323-1.323h0A1.323,1.323,0,0,1,93.35,99.129Z",
    transform: "translate(-3.143 -17.149)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2911",
    "data-name": "Rect\\xE1ngulo 2911",
    d: "M69.677,28.546H75.63a.662.662,0,0,1,.661.661h0a.662.662,0,0,1-.661.661H69.677a.662.662,0,0,1-.661-.661h0A.662.662,0,0,1,69.677,28.546Z",
    transform: "translate(-8.46 -19.949)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2931",
    "data-name": "Rect\\xE1ngulo 2931",
    width: 13.227,
    height: 1.984,
    rx: 0.992,
    transform: "translate(39.188 70.758)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2932",
    "data-name": "Rect\\xE1ngulo 2932",
    width: 11.904,
    height: 1.984,
    rx: 0.992,
    transform: "translate(86.623 70.758)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2914",
    "data-name": "Rect\\xE1ngulo 2914",
    d: "M110.557,28.546h7.274a.662.662,0,0,1,.661.661h0a.662.662,0,0,1-.661.661h-7.274a.662.662,0,0,1-.661-.661h0A.662.662,0,0,1,110.557,28.546Z",
    transform: "translate(-5.8 -19.949)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2912",
    "data-name": "Rect\\xE1ngulo 2912",
    width: 7.936,
    height: 0.661,
    rx: 0.331,
    transform: "translate(81.396 8.597)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2913",
    "data-name": "Rect\\xE1ngulo 2913",
    width: 7.936,
    height: 0.661,
    rx: 0.331,
    transform: "translate(81.396 9.92)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2906",
    "data-name": "Rect\\xE1ngulo 2906",
    width: 11.243,
    height: 0.661,
    rx: 0.331,
    transform: "translate(61.944 5.952)",
    fill: "#e68855"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2907",
    "data-name": "Rect\\xE1ngulo 2907",
    width: 11.243,
    height: 0.661,
    rx: 0.331,
    transform: "translate(85.172 5.952)",
    fill: "#e68855"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_285",
    "data-name": "Elipse 285",
    cx: 6.282,
    cy: 6.282,
    r: 6.282,
    transform: "translate(106.079 39.078)",
    fill: "#e5e9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2929",
    "data-name": "Rect\\xE1ngulo 2929",
    d: "M100.077,69.931h3.968a.662.662,0,0,1,.661.661h0a.662.662,0,0,1-.661.661h-3.968a.662.662,0,0,1-.661-.661h0A.662.662,0,0,1,100.077,69.931Z",
    transform: "translate(-8.469 -18.411)",
    fill: "#e68855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2930",
    "data-name": "Rect\\xE1ngulo 2930",
    d: "M114.441,69.931h5.291a.662.662,0,0,1,.661.661h0a.662.662,0,0,1-.661.661h-5.291a.662.662,0,0,1-.661-.661h0A.662.662,0,0,1,114.441,69.931Z",
    transform: "translate(-6.378 -18.411)",
    fill: "#898b8d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpPassport);
export default __webpack_public_path__ + "static/media/helpPassport.12f96613ede997e20cd8df08a45a5188.svg";
export { ForwardRef as ReactComponent };